// Module
var code = "<div class=\"step-feedback row no-margin\" ng-class=\"ctrl.messagePosition()\"> <div class=\"col-lg-12 col-md-12 no-padding\"> <span class=\"font-small\" ng-class=\"ctrl.messageType()\" ng-bind-html=\"ctrl.message.text || ctrl.message\"></span> </div> </div>";
// Exports
module.exports = code;